/**
 *
 * ConfirmationDialog
 *
 */
import * as React from 'react';
import styled from 'styled-components/macro';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
interface Props {}

export interface ConfirmationDialogProps {
  id?: string;
  keepMounted?: boolean;
  open: boolean;
  onClose: (value?: string) => void;
  onCancel?: (value?: string) => void;
  onConfirm: () => void;
  confirmButtonText: string,
  title?: string,
  children: any;
}

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const { onClose, onConfirm, open, confirmButtonText, title, ...other } = props;

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onConfirm();
  };

  return (
      <Dialog
          sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
          maxWidth="xs"
          open={open}
          {...other}
      >
        {title && (
          <DialogTitle>{title}</DialogTitle>
            )}
        <DialogContent dividers>
          {props.children}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel}>
            Back
          </Button>
          <Button onClick={handleOk}>{confirmButtonText}</Button>
        </DialogActions>
      </Dialog>
  );
}

const Div = styled.div``;
